const initialState = [];

function reducer(state = initialState, action) {
    if (action.type === 'ISSUE_COMPONENTS_SUCCESS') {
        return action.payload;
    }

    return state;
}

export default reducer;
